import React, { useState, useRef, useEffect } from "react";
import "./banner.css";
import "./header.css";
import cardsImage from "../../assets/BannerSection/bannerimg.svg";
import crownIcon from "../../assets/BannerSection/crown.svg";
import moneyIcon from "../../assets/BannerSection/money-recive.svg";
import lightningIcon from "../../assets/BannerSection/cloud-lightning.svg";
import autonomousLogoBlue from "../../assets/BannerSection/autonomousops-blue-logo.svg";
import autonomousLogoWhite from "../../assets/BannerSection/autonomousops-white-logo.svg";
import config from "../../config";
const Banner = () => {
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const navLinks = useRef([]);
  const [ids] = useState({
    "About Us": "one",
    Benefits: "two",
    "Use cases": "three",
    FAQ: "four",
  });
  const [logo, setLogo] = useState(autonomousLogoBlue);
  const scrollToSection = (id) => {
    const headerOffset = 100;
    const sectionElement = document.getElementById(id);
    const elementPosition = sectionElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const link = navLinks.current.find(
            (link) => link.dataset.target === entry.target.id
          );
          if (entry.isIntersecting) {
            link.classList.add("redirection-active");
          } else {
            link.classList.remove("redirection-active");
          }
        });
      },
      { threshold: [0.4] }
    );

    navLinks.current.forEach((link) => {
      if (!link) return;
      const sectionId = link.dataset.target;
      const sectionElement = document.getElementById(sectionId);
      observer.observe(sectionElement);
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(event.target)
    ) {
      setIsMenuActive(false);
    }
  };

  useEffect(() => {
    if (isMenuActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuActive]);

  const handleScroll = () => {
    const diff = window.innerWidth < 1024 ? 70 : 150;
    setIsHeaderActive(window.scrollY > diff);
    setLogo(window.scrollY > diff ? autonomousLogoBlue : autonomousLogoWhite);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    handleScroll(); // To set initial state on mount
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        const mobileHamburger = document.querySelector(".mobile-hamburger");
        const mainMenu = document.querySelector(".main-navigation__menu");

        if (mobileHamburger) {
          mobileHamburger.classList.remove("is-activeHamburger");
        }
        if (mainMenu) {
          mainMenu.classList.remove("main-navigation__menu-active");
        }
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <section className="banner-section">
      <div className="container">
        {/* Header */}
        <header
          className={`pricing-header header ${isHeaderActive ? "active" : ""}`}
        >
          <div className="container">
            <nav>
              <div className="elixir-logo">
                <img src={logo} alt="autonomousops-ai-logo" />
              </div>
              <ul className="headder-content" ref={menuRef}>
                {["About Us", "Benefits", "Use cases", "FAQ"].map(
                  (item, index) => (
                    <li
                      key={index}
                      className="elixirdata-hover-element-header"
                      tabIndex="0"
                    >
                      <a
                        href={`#${ids[item]}`}
                        data-target={ids[item]}
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToSection(ids[item]);
                        }}
                        ref={(el) => navLinks.current.push(el)}
                      >
                        <p className="platform">{item}</p>
                      </a>
                    </li>
                  )
                )}
              </ul>
            </nav>
            <div
              className={`mobile-navigation-header ${
                isHeaderActive ? "mobile-active" : ""
              }`}
            >
              <div className="mobile-logo-side">
                <a href="https://example.com">
                  <div className="elixir-logo">
                    <img src={logo} alt="autonomousops-ai-logo" />
                  </div>
                </a>
              </div>
              <div
                className={`mobile-hamburger ${
                  isMenuActive ? "is-activeHamburger" : ""
                }`}
                onClick={handleHamburgerClick}
                ref={hamburgerRef}
              >
                <div className="hamburger" id="hamburger-6">
                  <span className="line"></span>
                  <span className="line"></span>
                  <span className="line"></span>
                </div>
              </div>
            </div>
            <nav
              className={`main-navigation__menu ${
                isMenuActive ? "main-navigation__menu-active" : ""
              }`}
            >
              <div className="container">
                <ul id="redirection-links" ref={menuRef}>
                  {["About Us", "Benefits", "Use cases", "FAQ"].map(
                    (item, index) => (
                      <li key={index} tabIndex="0">
                        <a
                          href={`#${ids[item]}`}
                          data-target={ids[item]}
                          onClick={(e) => {
                            e.preventDefault();
                            scrollToSection(ids[item]);
                            setIsMenuActive(false);
                          }}
                          ref={(el) => navLinks.current.push(el)}
                        >
                          <p>{item}</p>
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </header>
        {/* Banner Content */}
        <div class="banner-content-wrapper">
          <div class="left-side">
            <h2>CUSTOMER OPERATIONS, SOC, INFORMATION TECHNOLOGY</h2>
            <h1>AutonomousOps AI Seamless Ops Automation</h1>
            <p>
              Driving Operational Efficiency and Productivity with Agents and
              teammates
            </p>
            <div class="banner-button-wrapper">
              <button
                class="banner-button"
                onClick={() => (window.location.href = config.bookdemo.Link)}
              >
                <p>Book Demo</p>
              </button>
            </div>
          </div>
          <div class="right-side">
            <img
              src={cardsImage}
              alt="Investigation, Alerts, and Recommendation"
              class="cards-image"
            />
          </div>
        </div>
        <div class="banner-cards-wrapper row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="banner-card-inner">
              <img src={crownIcon} alt="crown-icon" />
              <h2>IT Operations</h2>
              <p>
                AutonomousOps AI automates IT processes for faster resolutions.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="banner-card-inner">
              <img src={moneyIcon} alt="money-icon" />
              <h2>Security Operations</h2>
              <p>
                AutonomousOps AI ensures real-time threat detection and
                response.
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="banner-card-inner">
              <img src={lightningIcon} alt="cloud-lightning-icon" />
              <h2>Customer Operations</h2>
              <p>
                AutonomousOps AI automates customer support for quicker
                responses.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
